import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import { Camera, X } from "lucide-react";

export default function StaffPhotoUpload({ value, name, color, onChange, t }) {
  const ref = useRef(null);
  const [uploading, setUploading] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await axios.post(`${API}/uploads/image`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload error");
    } finally {
      setUploading(false);
      if (ref.current) ref.current.value = "";
    }
  };
  return (
    <div className="flex items-center gap-3" data-testid="staff-photo-block">
      <div className="relative w-16 h-16 rounded-full overflow-hidden border-2 flex items-center justify-center text-white text-xl font-bold shrink-0"
        style={{ borderColor: color || "#000", background: value ? "#f3f4f6" : (color || "#9ca3af") }}>
        {value ? <img src={value} alt="" className="w-full h-full object-cover" data-testid="staff-photo-img" /> : (name || "?").trim().charAt(0).toUpperCase()}
      </div>
      <div className="flex flex-col gap-1">
        <button type="button" onClick={() => ref.current?.click()} disabled={uploading} data-testid="staff-photo-upload-btn"
          className="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border-2 border-black hover:bg-black hover:text-white disabled:opacity-50">
          <Camera className="w-3.5 h-3.5" /> {uploading ? "…" : (value ? t("team.photoChange") : t("team.photoUpload"))}
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} data-testid="staff-photo-remove-btn"
            className="flex items-center gap-1 text-[11px] text-gray-500 hover:text-red-600"><X className="w-3 h-3" /> {t("team.photoRemove")}</button>
        )}
        <span className="text-[10px] text-gray-400">{t("team.photoHint")}</span>
      </div>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid="staff-photo-input" />
    </div>
  );
}
